import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListChecks, Plus, Upload } from 'lucide-react';
import LeadsTable from '../components/leads/LeadsTable';
import NewLeadModal from '../components/leads/NewLeadModal';
import CsvImportModal from '../components/leads/CsvImportModal';
import { Button } from '../components/ui/button';

const Leads = () => {
  const navigate = useNavigate();
  const [showNewLeadModal, setShowNewLeadModal] = useState(false);
  const [showCsvImportModal, setShowCsvImportModal] = useState(false);

  return (
    <div className="space-y-5 px-4 py-4 lg:px-0 lg:py-0">
      {/* ── Desktop header (unchanged) ─────────────────────────────────────── */}
      <div className="hidden lg:flex items-center justify-between">
        <div className="flex items-center gap-3">
          <ListChecks className="h-8 w-8 text-primary" />
          <div>
            <h1 className="text-3xl font-bold text-secondary">Leads</h1>
            <p className="text-muted-foreground">Manage all your leads in one place</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {/* Import Leads Button — basic 9-column prospect import. */}
          <Button
            onClick={() => setShowCsvImportModal(true)}
            variant="outline"
            className="shadow-sm"
            data-testid="leads-import-leads-btn"
          >
            <Upload className="h-4 w-4 mr-2" />
            Import Leads
          </Button>

          <Button
            onClick={() => setShowNewLeadModal(true)}
            className="text-white shadow-sm"
            style={{ backgroundColor: 'var(--cb-orange)' }}
          >
            <Plus className="h-4 w-4 mr-2" />
            New Lead
          </Button>
          <div className="flex bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
            <button
              onClick={() => navigate('/pipeline')}
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
            >
              Pipeline
            </button>
            <button
              className="px-4 py-2 text-sm font-medium transition-colors"
              style={{ backgroundColor: 'var(--cb-orange)', color: 'white' }}
            >
              List View
            </button>
          </div>
        </div>
      </div>

      {/* ── Mobile header — compact, New Lead primary ──────────────────────── */}
      <div className="lg:hidden flex items-center justify-between gap-2">
        <h1 className="text-2xl font-bold text-gray-900">Leads</h1>
        <div className="flex items-center gap-2">
          {/* Pipeline — de-emphasised text link */}
          <button
            type="button"
            onClick={() => navigate('/pipeline')}
            className="text-sm text-gray-500 font-medium px-3 min-h-[44px] flex items-center rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="leads-pipeline-link"
          >
            Pipeline
          </button>
          {/* New Lead — primary CTA */}
          <Button
            onClick={() => setShowNewLeadModal(true)}
            className="text-white shadow-sm min-h-[44px]"
            style={{ backgroundColor: 'var(--cb-orange)' }}
            data-testid="leads-new-lead-btn"
          >
            <Plus className="h-4 w-4 mr-1.5" />
            New Lead
          </Button>
        </div>
      </div>

      {/* Leads Table */}
      <LeadsTable />

      {/* CSV Import Modal — leads mode (prospects only) */}
      <CsvImportModal
        isOpen={showCsvImportModal}
        onClose={() => setShowCsvImportModal(false)}
        mode="leads"
      />

      {/* New Lead Modal */}
      <NewLeadModal
        isOpen={showNewLeadModal}
        onClose={() => setShowNewLeadModal(false)}
      />
    </div>
  );
};

export default Leads;